/**
 * @param {string[]} ids
 * @param {object[{_id}]} assets
 *  @returns {boolean}
* */
export default function hasAllAssets(ids, assets) {
  return ids.every((id) => assets.findIndex(({ _id }) => _id === id) > -1);
}
